module.exports = __webpack_public_path__ + "static/media/cinemaImage.6272d0ed.jpg";